module.exports = __webpack_public_path__ + "img/hdd-rack-fill.ea666b87.svg";